/* Clinica Vie Et Sante - 08 Testimonios
   Boton de pausa de la cinta (WCAG 2.2.2). El desplazamiento y la pausa por
   hover/foco los hace el CSS; el boton es el control persistente. */

class VesQuotes {
  constructor(root) {
    this.track = root.querySelector('[data-track]');
    this.pauseBtn = root.querySelector('[data-pause]');

    // velocidad desde el data del select
    const speed = root.dataset.speed;
    if (speed === 'slow') root.classList.add('ves-quotes--slow');
    if (speed === 'fast') root.classList.add('ves-quotes--fast');

    if (this.track && this.pauseBtn) this.bind();
  }

  bind() {
    this.pauseBtn.addEventListener('click', () => {
      const paused = this.track.classList.toggle('is-paused');
      this.pauseBtn.setAttribute('aria-pressed', String(paused));
      const label = this.pauseBtn.querySelector('.visually-hidden');
      if (label) label.textContent = paused ? 'Reanudar el desplazamiento' : 'Pausar el desplazamiento';
    });
  }
}

function initVesQuotes() {
  document.querySelectorAll('[data-ves-quotes]').forEach((el) => {
    if (el.dataset.vesInit === 'true') return;
    el.dataset.vesInit = 'true';
    new VesQuotes(el);
  });
}

document.addEventListener('DOMContentLoaded', initVesQuotes);
document.addEventListener('shopify:section:load', initVesQuotes);
